const twelvedataPriceTarget = {
  high: 48.4,
  median: 45.5,
  low: 40,
  average: 44.5,
  current: 42.3,
  currency: 'SAR',
};
export default twelvedataPriceTarget;
